import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  filterObj: {
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 10
    ),
    dateTo: new Date(),
    loc: "",
    status: "ALL",
  },
  Head: {
    A_Id: 0,
    A_Date: new Date(),
    A_Loc: "",
    A_LocName: "",
    A_Narr: "",
    A_Status: "ENTER",
    A_Confirm_Status: "ENTER",
  },
  // Detail: [
  //   {
  //     srNo: 0,
  //     barCode: 0,
  //     itemName: "",
  //     arabicName: "",
  //     subCategory: "",
  //     mainCategory: "",
  //     category: "",
  //     packing: "",
  //     brand: "",
  //     vendor: "",
  //     costPrice: 0,
  //     rsp: 0,
  //   },
  // ],
};

const SliceItemCreationRequest = createSlice({
  name: "SliceItemCreationRequest",
  initialState: { value: initialState },

  reducers: {
    Head_Set: (state, action) => {
      state.value.Head = action.payload;
    },
    Head_Set_Init: (state, action) => {
      state.value.Head = initialState.Head;
    },
    // Detail_Set: (state, action) => {
    //   state.value.Detail = action.payload;
    // },
    FilterObj_Set: (state, action) => {
      state.value.filterObj = action.payload;
    },
    ItemCreationRequest_Init: (state) => {
      state.value = initialState;
    },
  },
});

export const { Head_Set, ItemCreationRequest_Init, Detail_Set, FilterObj_Set ,Head_Set_Init} =
  SliceItemCreationRequest.actions;
export default SliceItemCreationRequest.reducer;
